import styled from 'styled-components';

export const MobileAssetInfoWrapperStyled = styled.div`
    padding: 16px;
    background: #8192E433;
    border-radius: 16px;
    
    table {
        width: 100%;
    }
    
    tr {
        display: flex;
        width: 100%;
        &:not(:first-child) {
            margin-top: 16px;
        }
    }
    th {
        flex: 0 0 25%;
        color: var(--color-white-60);
        font-weight: 500;
    }
    td {
        flex: 1;
    }
`;
